import React from 'react';
import classnames from 'classnames';
import ReactPaginate from 'react-paginate';
import { createUseStyles, useTheme } from 'react-jss';

import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  paginationNav: {
    display: 'flex',
    alignItems: 'center',
    listStyle: 'none',
  },
  paginationElmt: {
    color: theme.colors.inkTertiary,
    minHeight: theme.height.small,
    padding: theme.marginBase,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  arrowPaginationElmt: {
    minWidth: theme.height.small,
  },
  activePage: {
    backgroundColor: theme.colors.grayBackground,
    color: theme.colors.blueAccessible,
  },
  paginationElmtDisabled: {
    opacity: 0.5,
    '& > a': {
      cursor: 'auto',
    },
  },
}));

interface Props {
  pageCount: number;
  gotoPage: (page: number) => any;
  page: number;
}

export const TablePagination = ({ page, pageCount, gotoPage }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <ReactPaginate
      pageCount={pageCount}
      pageRangeDisplayed={3}
      forcePage={page}
      marginPagesDisplayed={1}
      previousLabel={<i className="ri-arrow-left-s-line" />}
      nextLabel={<i className="ri-arrow-right-s-line" />}
      onPageChange={({ selected }) => gotoPage(selected)}
      containerClassName={classes.paginationNav}
      pageLinkClassName={classes.paginationElmt}
      activeLinkClassName={classes.activePage}
      previousLinkClassName={classnames(
        classes.paginationElmt,
        classes.arrowPaginationElmt,
      )}
      nextLinkClassName={classnames(
        classes.paginationElmt,
        classes.arrowPaginationElmt,
      )}
      breakLinkClassName={classes.paginationElmt}
      disabledClassName={classes.paginationElmtDisabled}
    />
  );
};
